import React, { Component, PropTypes } from 'react';
import difference from 'lodash/difference';
import union from 'lodash/union';
import every from 'lodash/every';
import partial from 'lodash/partial';
import without from 'lodash/without';
import { CheckBoxField } from 'common/components/form_fields';

export default class SubcategoriesField extends Component {
  constructor(props) {
    super(props);

    this.state = { openCategories: {} };

    this.toggleCategoryOpen = this.toggleCategoryOpen.bind(this);
    this.renderCategory = this.renderCategory.bind(this);
    this.renderSubcategory = this.renderSubcategory.bind(this);
  }

  toggleCategoryOpen(category) {
    const { openCategories } = this.state;
    this.setState({
      openCategories: { ...openCategories, [category]: !openCategories[category] }
    });
  }

  renderSubcategory(subcat) {
    const { input } = this.props;
    const value = input.value || [];
    const checked = value.includes(subcat.id);

    return (
      <CheckBoxField input={{
        name: `subcategory_${subcat.id}`,
        value: checked,
        onChange: (v) => input.onChange(v? value.concat(subcat.id) : without(value, subcat.id))
      }} label={subcat.name} key={subcat.id} meta={{}} />
    );
  }

  renderCategory(category) {
    const { categories, input } = this.props;
    const value = input.value || [];
    const isCategoryOpen = this.state.openCategories[category];
    const subcategories = categories[category];

    return (
      <div className="category" key={category}>
        <CheckBoxField input={{
          name: `category_${category}`,
          value: every(subcategories, subcat => value.includes(subcat.id)),
          onChange: (v) => {
            const ids = subcategories.map(subcat => subcat.id);
            input.onChange(v? union(value, ids) : difference(value, ids))
          }
        }} label={category} meta={{}} />

        <i className={"fa fa-" + (isCategoryOpen? "minus" : "plus")}
          onClick={partial(this.toggleCategoryOpen, category)} />

        { isCategoryOpen && subcategories.map(this.renderSubcategory) }
      </div>
    );
  }

  render() {
    const { categories, label, meta } = this.props;
    const hasError = meta.touched && meta.invalid;

    return (
      <div className="sub-categories-field">
        <label className="form-label top-label">{ label }</label>
        { Object.keys(categories).map(this.renderCategory) }
        { hasError && <span className="text-danger">{ meta.error }</span> }
      </div>
    );
  }
}

SubcategoriesField.propTypes = {
  categories: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./common/components/sub_categories_field.jsx